import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { calcSizeForDevice } from 'utils/index';

import { AccountNotFoundModalProps } from 'components/AccountDeactivated/AccountNotFoundModal';
import {
  ACCOUNT_NOT_FOUND_BUTTON,
  ACCOUNT_NOT_FOUND_CLOSE_EVENT,
  ACCOUNT_NOT_FOUND_MESSAGE,
  ACCOUNT_NOT_FOUND_TITLE,
  ACCOUNT_NOT_FOUND_TV_CLASS,
} from 'components/AccountDeactivated/AccountNotFoundModal/constants';
import { WebDiv } from 'components/WebDiv';

export const TvAccountNotFoundModal = ({
  isOpen,
  onClose,
}: AccountNotFoundModalProps): React.ReactNode => {
  useEffect(() => {
    if (!isOpen) return;

    window.addEventListener(ACCOUNT_NOT_FOUND_CLOSE_EVENT, onClose);

    return () => {
      window.removeEventListener(ACCOUNT_NOT_FOUND_CLOSE_EVENT, onClose);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <WebDiv
      className={`fullscreen-overlay navigation-container navigation-priority ${ACCOUNT_NOT_FOUND_TV_CLASS}`}>
      <View style={styles.overlay}>
        <View style={styles.container}>
          <Text style={styles.title}>{ACCOUNT_NOT_FOUND_TITLE}</Text>

          <Text style={styles.text}>{ACCOUNT_NOT_FOUND_MESSAGE}</Text>

          <Pressable accessibilityRole="button" style={styles.closeBtn} onPress={onClose}>
            <Text style={styles.closeBtnText}>{ACCOUNT_NOT_FOUND_BUTTON}</Text>
          </Pressable>
        </View>
      </View>
    </WebDiv>,
    document.getElementById('root')!
  ) as React.ReactPortal;
};

const styles = StyleSheet.create({
  overlay: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.85)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    width: calcSizeForDevice(540),
    padding: calcSizeForDevice(40),
    backgroundColor: '#050923',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#182DB3',
  },
  title: {
    fontSize: calcSizeForDevice(32),
    fontWeight: '700',
    color: '#7A8CFF',
    textAlign: 'center',
    marginBottom: 24,
  },
  text: {
    color: '#FFF',
    fontSize: calcSizeForDevice(20),
    textAlign: 'center',
  },
  closeBtn: {
    width: '100%',
    height: calcSizeForDevice(54),
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: calcSizeForDevice(32),
  },
  closeBtnText: {
    color: '#FFF',
    fontSize: calcSizeForDevice(18),
  },
});
